import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueJsonp from 'vue-jsonp'
// Esp通用组件
import EspCommon from './components/common'
// 全局变量
import EspConstant from './utils/constant'
// 全局样式
import './styles/element-ui.scss'
import './styles/global.less'
import './assets/icon/iconfont.css'
import './assets/icon/iconfont.js'
// Dialog弹框的移动和全屏
import './assets/dialog/move_full.js'

EspCommon.forEach(component => {
  Vue.component(component.name, component);
});

Vue.prototype.espConstant = EspConstant;

Vue.use(ElementUI, {size: 'small', zIndex: 3000});
Vue.use(VueJsonp);
Vue.config.productionTip = false;

// 千分位
Vue.filter('toNumberZero', function (data) {
  if (data == null || data == undefined || data == '' || data == 0) {
    return 0.00;
  }
  if (typeof (data) === 'number') {
    return (data).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  }
  return data;
});

// 全局自定义指令
Vue.directive('focus', {
  inserted(el, binding) {
    el.querySelector('input').focus()
  }
})

new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js